import React from "react";
import { Shell } from "@/shell/Shell";
import { PageHeader } from "@/shell/PageHeader";
import { StatusBanner } from "@/shell/components/StatusBanner";
import "@/features/vb360/styles/vb360.css";

export type Vb360StateKind = "forbidden" | "unavailable";

export const vb360StateCopy: Record<Vb360StateKind, { severity: "critical" | "warning"; title: string; detail: string }> = {
    forbidden: {
        severity: "critical",
        title: "VB360 no está disponible para esta sesión",
        detail: "VB360 está apagado en este entorno o tu sesión no incluye un email. Vuelve a iniciar sesión en Metrics.",
    },
    unavailable: {
        severity: "warning",
        title: "Fuente no disponible",
        detail: "No se pudieron cargar los datos de VB360. Inténtalo más tarde.",
    },
};

export const Vb360StatePage: React.FC<{ kind: Vb360StateKind }> = ({ kind }) => (
    <Shell>
        <PageHeader title="VB360" lede="Ficha de identidad de una cuenta del piloto." />
        <StatusBanner severity={vb360StateCopy[kind].severity} title={vb360StateCopy[kind].title} sub={vb360StateCopy[kind].detail} />
    </Shell>
);
